<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <NormalButton
          :text="buttonName"
          btnClass="text-none"
          height="32px"
          width="150px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <ShopDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="shopTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getPlatformListFromState()"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.name`]="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #[`item.country`]="{ item }">
              <div>{{ getPlatFormCountry(item) }}</div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.edit`]="{ item }">
              <WhiteButton
                text="common.common_edit"
                height="32px"
                width="48px"
                @click.native="edit(item)"
              />
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <ShopDialog
      v-model="dialogInfo.edit"
      :shopData="shopData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import { ShopDialog } from '@/components/layouts/Dialogs'
import { NormalButton, WhiteButton } from '@/components/items'
import _cloneDeep from 'lodash/cloneDeep'
import { platformUtil } from '@/util'

export default {
  components: {
    Master,
    ShopDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'jd.jd_jdcom-store-management',
      buttonName: 'jd.jd_jdcom-store-register',
      shopData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: headers.headers,
      itemKey: 'shopId',
      editMode: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  methods: {
    ...mapActions('Platform', ['getPlatformListFromApi']),
    ...mapGetters('Platform', ['getPlatformListFromState']),
    async init() {
      await this.getPlatformListFromApi()
    },
    edit(shop) {
      this.shopData = _cloneDeep(shop)
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    getPlatFormCountry(item) {
      return platformUtil.getPlatformCountryById(item.platformCountryId).label
    }
  }
}
</script>
<style scoped lang="scss">
.shopTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
</style>
